import styled, { css } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const ButtonHeader = styled.button.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "button-header",
})<{ $active?: boolean }>`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 8px;
  border: none;
  background-color: inherit;
  color: ${blueGreyMui._500};
  padding: 6px;
  border-radius: 4px;
  &:hover {
    background-color: ${blueGreyMui._50};
  }
  ${({ $active }) =>
    $active &&
    css`
      background-color: ${blueGreyMui._50};
    `};
  &:focus-visible {
    outline: 2px solid ${blueGreyMui._700};
    outline-offset: 2px;
  }
  &:disabled {
    cursor: default;
    opacity: 0.4;
    background-color: inherit;
  }
  svg {
    width: 20px;
    height: 20px;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 12px;
    line-height: 14px;
    gap: 4px;
    padding: 4px;
  }
`;
